module.exports = __webpack_public_path__ + "img/Difarmer-introduccion.931403fe.png";